<template>
  <a v-scroll-to="'#app'" v-show="visible" class="bottom-right">
    <b-button><b-icon-chevron-up /></b-button>
  </a>
</template>

<script>
import { BIconChevronUp } from "bootstrap-vue";

export default {
  name: "ScrollToTop",
  components: {
    BIconChevronUp,
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    scrollListener: function () {
      this.visible = window.scrollY > 150;
    },
  },
  mounted: function () {
    window.addEventListener("scroll", this.scrollListener);
  },
  beforeDestroy: function () {
    window.removeEventListener("scroll", this.scrollListener);
  },
};
</script>

<style scoped>
.bottom-right {
  position: fixed;
  bottom: 20px;
  right: 20px;
  cursor: pointer;
  opacity: 0.5;
}

.bottom-right:hover {
  opacity: 1;
}
</style>